import React from 'react'
import Cart from './Cart'
import Sidebar from './Sidebar'
import { useSelector } from 'react-redux'

const Navbar = () => {

  const {cartItems} = useSelector(state=>state.cart)

  return (
    <>
    <Sidebar/>
    <Cart/>
      <nav className="navbar navbar-expand navbar-light">
      <div className="container">
        <a className="navbar-brand" href="/">
          <img src="/assets/img/logo.png" alt="" />
          {/* GETART. */}
        </a>
        <ul className="navbar-nav d-none d-md-flex ml-auto">
          <li className="nav-item">
            <a className="nav-link" data-toggle="modal" href="#modalSearch">
              <i className="bi bi-search"></i>
            </a>
          </li>
          <li className="nav-item ml-lg-n4">
            <a className="nav-link" href="/user/myorders">
              <i className="bi bi-person"></i>
            </a>
          </li>
          <li className="nav-item ml-lg-n4">
            <a className="nav-link" data-toggle="modal" href="#modalShoppingCart">
              {cartItems.lenght !== 0 ? 
              <span data-cart-items={cartItems.length}>
                <i className="bi bi-cart"></i>
              </span>
              : <span> 
                <i className="bi bi-cart"></i>
              </span>}
            </a>
          </li>
        </ul>
        <button className="navbar-toggler d-block ml-7" type="button" data-toggle="modal" data-target="#modalSidebar" style={{outline:"none"}}>
          <span className="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>
    </>
  )
}

export default Navbar